export default __webpack_public_path__ + "static/media/lock.264de64f.svg";